import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";

import api from "api";
import actions from "actions";
import util from "utils/utils";

import AgreeToTerms from "components/lib/Entry/AgreeToTerms";
import VerifyEmail from "components/lib/Entry/VerifyEmail";
import InitialProfileSetup from "components/lib/Entry/InitialProfileSetup";
import OrgTagChooser from "components/lib/Choosers/Tags/OrgTagChooser";

import CustomOnboarding from "./lib/CustomOnboarding";

import AppRouting from "./app/AppRouting";

import { useAppDispatch, useAppSelector } from "store";
import CreateBusinessProfile from "./lib/Entry/CreateBusinessProfile";

const AppOnboarding = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const userId = user?._id;

  const [showingTagChooser, setShowingTagChooser] = useState(null);
  const [resumingSession, setResumingSession] = useState(true);
  const userHasVerifiedEmail = util.hasVerifiedEmail(user, user?.ownerOrganisation);

  useEffect(() => {
    if (userId && userHasVerifiedEmail) {
      api.users.getOrganisations(
        userId,
        (orgs) => {
          dispatch(actions.user.updateAvailableOrganisations(orgs));
        },
        () => {},
      );
    }
  }, [userId, userHasVerifiedEmail, dispatch]);

  useEffect(() => {
    setResumingSession(true);
    api.auth.resumeSession(
      () => setResumingSession(false),
      () => setResumingSession(false),
    );
  }, []);

  useEffect(() => {
    if (showingTagChooser === null && user && user?.ownerOrganisation) {
      setShowingTagChooser(util.shouldShowInterestsChooser(user));
    }
  }, [showingTagChooser, user]);

  if (resumingSession) return <Loader active inline="centered" style={{ marginTop: 30 }} />;
  if (user && !util.hasAgreedTerms(user)) return <AgreeToTerms />;
  if (user && !userHasVerifiedEmail && window.location.pathname !== "/verify-email") return <VerifyEmail />;
  if (user && !(user.profile?.firstName && user.profile?.lastName)) return <InitialProfileSetup />;
  if (user && !user.hasCompletedOrganisationOnboarding) return <CustomOnboarding />;
  if (user && user.needsBusinessProfile) return <CreateBusinessProfile />;
  if (showingTagChooser) return <OrgTagChooser setVisible={setShowingTagChooser} />;

  return <AppRouting />;
};

export default AppOnboarding;
